import "../../styles/Banner.css";
import React from "react";
import Img from "../../Images/Banner/branding-fda-nav.png";
function Banner() {
  const title = "Créez votre propre Fleur de l'Agroécologie";
  const goToWebsite = () => {
    window.location = "https://fermesdavenir.org/";
  };
  return (
    <div className="fa_banner">
      <input
        type="image"
        className="fda_logo"
        src={Img}
        onClick={() => {
          goToWebsite();
        }}
      />
      <span className="borders"></span>
      <h1 className="title">{title}</h1>
    </div>
  );
}
export default Banner;
